import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../services/api';
import '../styles/common.css';

function ParentLogin() {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // 컴포넌트 마운트시 저장된 로그인 정보 불러오기
  useEffect(() => {
    const savedEmail = localStorage.getItem('savedEmail');
    const savedPassword = localStorage.getItem('savedPassword');

    if (savedEmail && savedPassword) {
      setFormData({
        email: savedEmail,
        password: savedPassword
      });
      setRememberMe(true);
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await api.post('/auth/parent/login', formData);
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));

      // 로그인 정보 저장/삭제 처리
      if (rememberMe) {
        localStorage.setItem('savedEmail', formData.email);
        localStorage.setItem('savedPassword', formData.password);
      } else {
        localStorage.removeItem('savedEmail');
        localStorage.removeItem('savedPassword');
      }

      // 부모 대시보드로 리다이렉트
      navigate('/parent/dashboard');
    } catch (error) {
      setError(error.response?.data?.error || '로그인 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card">
      <h1 className="title">👨‍👩‍👧‍👦 부모님 로그인</h1>
      <p className="subtitle">가족 관리를 시작해보세요</p>

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">이메일</label>
          <input
            type="email"
            name="email"
            className="form-input"
            value={formData.email}
            onChange={handleInputChange}
            required
            data-testid="email-input"
          />
        </div>

        <div className="form-group">
          <label className="form-label">비밀번호</label>
          <input
            type="password"
            name="password"
            className="form-input"
            value={formData.password}
            onChange={handleInputChange}
            required
            data-testid="password-input"
          />
        </div>

        <div style={{ marginTop: '15px', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <input
            type="checkbox"
            checked={rememberMe}
            onChange={(e) => setRememberMe(e.target.checked)}
            data-testid="remember-checkbox"
          />
          <span style={{ fontSize: '0.9rem', color: '#666', whiteSpace: 'nowrap' }}>
            로그인 정보 기억하기
          </span>
        </div>

        {error && <div className="error" data-testid="error-message">{error}</div>}

        <button
          type="submit"
          className="btn btn-primary"
          disabled={loading}
          style={{ width: '100%', marginTop: '20px' }}
          data-testid="login-btn"
        >
          {loading ? '로그인 중...' : '로그인'}
        </button>
      </form>

      <div style={{ marginTop: '20px', textAlign: 'center' }}>
        <Link to="/parent/signup" style={{ color: '#8B4513', textDecoration: 'none' }}>
          계정이 없으신가요? 가족 등록하기
        </Link>
      </div>

      <div style={{ marginTop: '15px', textAlign: 'center' }}>
        <Link to="/" className="back-btn">
          ← 홈으로 돌아가기
        </Link>
      </div>
    </div>
  );
}

export default ParentLogin;